import { Button } from '@/components/Button'
import { TrademarkType } from '@/store/Calculator'
import cn from 'classnames'
import { FunctionComponent, ReactElement, useCallback } from 'react'
import { TrademarkCombine } from './resources/trademark_combine'
import { TrademarkImage } from './resources/trademark_image'
import { TrademarkWord } from './resources/trademark_word'
import styles from './TypesTrademark.module.scss'

interface TypesTrademarkProps {
  className?: string
  onSelect(value: TrademarkType): void
}
export const TypesTrademark: FunctionComponent<TypesTrademarkProps> = ({
  className,
  onSelect,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <Item
        type={TrademarkType.WORD}
        name="Словесный"
        image={<TrademarkWord className={styles.image} />}
        description="Словесный знак - состоит из слов, буквосочетаний, словосочетаний или предложений"
        onSelect={onSelect}
      />
      <Item
        type={TrademarkType.IMAGE}
        name="Изобразительный"
        image={<TrademarkImage className={styles.image} />}
        description="Изобразительный знак - состоит только из изображений и не содержит текст"
        onSelect={onSelect}
      />
      <Item
        type={TrademarkType.COMBINE}
        name="Комбинированный"
        image={<TrademarkCombine className={styles.image} />}
        description="Комбинированный знак - это комбинация различных элементов (слов и изображений)."
        onSelect={onSelect}
      />
    </div>
  )
}

interface ItemProps {
  type: TrademarkType
  name: string
  description: string
  image: ReactElement<any>
  onSelect(value: TrademarkType): void
}
const Item: FunctionComponent<ItemProps> = ({
  type,
  name,
  description,
  image,
  onSelect,
}) => {
  const select = useCallback(() => {
    onSelect(type)
  }, [type, onSelect])

  return (
    <div className={styles.item}>
      <div className={styles.name}>{name}</div>
      <div className={styles.content}>
        <div className={styles.imageWrap}>{image}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <Button onClick={select}>Выбрать</Button>
    </div>
  )
}
